import { Sandpack } from "@codesandbox/sandpack-react";
import { amethyst } from "@codesandbox/sandpack-themes";


export default () => {
  return (
    <Sandpack
      template="react"
      files={{ "/button.js": `export default () => <button />` }}
      theme={{
        colors: {
          accent: "rebeccapurple",
        },
        syntax: {
          tag: "#006400",
          string: "rgb(255, 165, 0)",
          plain: "tomato",
        },
      }}
      //theme={amethyst}
      options={{
        visibleFiles: ["/App.js", "/button.js", "/index.js"],
        activeFile: "/index.js",
        showNavigator: true,
        showLineNumbers: true, // default - true
        showInlineErrors: true, // default - false
        wrapContent: true, // default - false
        editorHeight: 1000, // default - 300
        editorWidthPercentage: 50, // default - 50
        recompileMode: "delayed",
        recompileDelay: 300,
        showConsole: true,
      	showConsoleButton: true,
      }}
    />
  )
}